import { useState, useEffect } from 'react';
import EditReservation  from './edit_reservation.js'
import  {Drawer, Stack, Box, Tabs, Tab, FormControl,
  Button, TextField, Select, MenuItem  } from '@mui/material'; 
import dataProvider from '../../lib/dataProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/en-gb';
import moment from 'moment';
import 'moment/dist/locale/de';

const EditGroup = ({showOpen, closeEdit, agenten, bookingchannels, alterskats, gastdetails, rowList, gridData}) => {
  const [group, setGroup] = useState([]);
  const [tab, setTab] = useState(0);
  const [selRes, setSelRes] = useState(null);
  const [selSplit, setSelSplit] = useState('arr');
  const [paydata, setPaydata] = useState({});
  const [paymenttypes, setPaymenttypes] = useState([]);
  const [addres, setAddres] = useState('');

  useEffect(() => {
    if (!showOpen) return;
    if (showOpen.id>0) {
      LoadGroup(showOpen.id);
    }
    else if (showOpen.info) {
    }
  }, [showOpen]);

  useEffect(() => {
    dataProvider.getList('setPaymenttype', { filter: {   }, sort: false, pagination: { page: 1, perPage: 999 } })
      .then(response => { if (response.data) { setPaymenttypes(response.data);}
    });
  }, []);

  const LoadGroup =(id) => {
    dataProvider.getOne('appGroup', { id })
      .then(response => {
        if (response.data) {
          setGroup(response.data);
          setSelRes(null);
          setSelSplit('arr');
          setPaydata({});
          setAddres('');
        }
      });
  }
  const addRes = () => {
    dataProvider.update('appGroup', {id:group[0].reservation_id, data:{action: 'addRes', res_nr: addres} })
    .then(res  => {
       LoadGroup(group[0].id_parent);
    })

  }

  const separateRes = () => {
    dataProvider.update('appGroup', {id:selRes, data:{action: 'separateRes'} })
    .then(res  => {
       LoadGroup(group[0].id_parent);
    })

  }

  if (!group.length) return null;

  console.log(['group', group]);
  if (false &&group.length < 2) {
    return (
      <Drawer anchor="right" open={showOpen!==false} onClose={closeEdit} >
        <EditReservation showOpen={showOpen} closeEdit={closeEdit} agenten={agenten} bookingchannels={bookingchannels} alterskats={alterskats}
          gastdetails={gastdetails} rowList={rowList} gridData={gridData} />
      </Drawer>
    )
  }
  let total = 0;
  let totalDue = 0;
  return (
    <Drawer anchor="right" open={showOpen!==false} onClose={closeEdit} >
      <Tabs value={tab} onChange={(e, v) => setTab(v)}>
        <Tab label="Group" />
{group.map((g, k) => <Tab label={`${g.res_nr} ${g.gast} ${moment(g.ankunft+'').format('YYYY-MM-DD')}(${g.dauer})`} />)}
      </Tabs>
      <Box sx={{display: tab===0?'block':'none'}}>
        <div className="textdisp" style={{marginTop:"1em"}}>
          <table className="grouplist">
            <thead>
              <tr>
                <th></th>
                <th>#Res</th>
                <th>Arrival</th>
                <th>Days</th>
                <th>Guest</th>
                <th>Price</th>
                <th>Due</th>
              </tr>
            </thead>
            <tbody>
              {group.map((g, k) => {
                total += g.netto+g.zusatz;
                totalDue += g.netto+g.zusatz-g.bezahlt;  
                return (
                <tr key={k}>
                  <td><input type="radio" name="grp" value={g.reservation_id} onChange={() => setSelRes(g.reservation_id)} checked={selRes===g.reservation_id} /></td>
                  <td onClick={() => setTab(k+1)}>{g.res_nr}</td>
                  <td onClick={() => setTab(k+1)}>{moment(g.ankunft+'').format('YYYY-MM-DD')}</td>
                  <td onClick={() => setTab(k+1)}>{g.dauer}</td>
                  <td onClick={() => setTab(k+1)}>{g.gast}</td>
                  <td onClick={() => setTab(k+1)}>{(g.netto+g.zusatz).toFixed(2)}</td>
                  <td onClick={() => setTab(k+1)}>{(g.netto+g.zusatz-g.bezahlt).toFixed(2)}</td>
                </tr>
              )})}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Total</td>
                <td>{total.toFixed(2)}</td>
                <td>{totalDue.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
          <Stack spacing={2} direction="row">
            <Button variant="outlined" onClick={separateRes} disabled={selRes===null}>Separate Reservation</Button>
            <input type="text" placeholder="#Res" value={addres} onChange={(ev) => setAddres(ev.target.value)} className="simpleinput" style={{width:'5em', marginLeft:'auto'}} data-lpignore="true" autoComplete="off" />
            <Button variant="outlined" onClick={addRes}>Add Reservation</Button>
          </Stack>
          <hr />

          <h5 style={{margin:'.5em 0'}}>Split</h5>
          <input type="radio" name="split" value="arr" onChange={() => setSelSplit('arr')} checked={selSplit==='arr'} />  Arrival Date <input type="date" /><br />
          <input type="radio" name="split" value="pers" onChange={() => setSelSplit('pers')} checked={selSplit==='pers'} /> Persons<br />
          <input type="radio" name="split" value="room" onChange={() => setSelSplit('room')} checked={selSplit==='room'} /> Rooms<br />
          <input type="radio" name="split" value="night" onChange={() => setSelSplit('night')} checked={selSplit==='night'} /> Every Night<br />
          <Button variant="outlined" onClick={addRes} sx={{position:'absolute', bottom:'1em', right:'1em'}} disabled={selRes===null}>Execute Split</Button>
        </div>
        <Box className="textdisp">
          <span>Group payment</span>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={'en-gb'}>
              <DateTimePicker
                views={['month', 'day', 'hours', 'minutes']}
                format="DD/MM/YYYY HH:mm"
                label="Date & Time"
                value={moment(paydata.datum)}
                onChange={(v) => setPaydata({...paydata, datum: v})}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>            
            <TextField label="Text" value={paydata.text} onChange={(ev) => setPaydata({...paydata, text: ev.target.value})} sx={{flex:2}} />
          </Stack>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <TextField label="Amount" value={paydata.betrag?paydata.betrag:totalDue.toFixed(2)} onChange={(ev) => setPaydata({...paydata, betrag: ev.target.value})} />
            <FormControl sx={{flex:2}} >
              <Select value={paydata.id_zahlungsart?paydata.id_zahlungsart:paymenttypes[0].id} onChange={(ev) => setPaydata({...paydata, id_zahlungsart: ev.target.value})}>
                {paymenttypes.map((pt) => {
                  return (
                    <MenuItem key={pt.id} value={pt.id} style={{display:'grid', gridTemplateColumns: 'auto 10% 50%'}}>
                      {pt.bezeichnung}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2} sx={{justifyContent: 'flex-end'}}>
            <Button variant="outlined" onClick={addRes}>Add Payment</Button>
          </Stack>
        </Box>
      </Box>
{group.map((g, k) => {
  const so = {id: g.reservation_id};
  return (
    <Box sx={{display: tab===k+1?'block':'none'}}>
      <EditReservation showOpen={so} closeEdit={closeEdit} agenten={agenten} bookingchannels={bookingchannels} alterskats={alterskats}
            gastdetails={gastdetails} rowList={rowList} gridData={gridData} />
    </Box>
)})}        
    </Drawer>


  )
}

export default EditGroup